module.exports = __webpack_public_path__ + "images/b568c8cd5f12cb88de920a1025c0d237.gif";